import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  private _dialogOpened = false;

  get dialogOpened() {
    return this._dialogOpened;
  }

  public openDialog<T, DataType = any, ReturnType = any>(
    dialogComponent: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<DataType>
  ): MatDialogRef<T, ReturnType> {
    this._dialogOpened = true;

    const dialog = this.dialog.open<T, DataType, ReturnType>(dialogComponent, {
      autoFocus: false,
      ...config
    });

    dialog.afterClosed().subscribe(() => {
      this._dialogOpened = false;
    });

    return dialog;
  }
}
